/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/4/2022.
 */

import {
    SET_ASSET_FAULT,
    REQUEST_OBSERVATIONS,
    RECEIVE_OBSERVATIONS,
    SET_OBSERVATION,
    REQUEST_SUBMIT_OBSERVATIONS,
    RECEIVE_SUBMIT_OBSERVATIONS,
    REQUEST_ACTIONS,
    RECEIVE_ACTIONS,
    REQUEST_SUBMIT_TEST_RESULT,
    RECEIVE_SUBMIT_TEST_RESULT,
    REQUEST_SUBMIT_CORRECTIVE_ACTION_RESULT,
    RECEIVE_SUBMIT_CORRECTIVE_ACTION_RESULT,
    REQUEST_SAVE_COMMENT,
    RECEIVE_SAVE_COMMENT,
    REQUEST_ACTION_LOG,
    RECEIVE_ACTION_LOG,
    REQUEST_COMMENTS,
    RECEIVE_COMMENTS,
    REQUEST_DETAILS,
    RECEIVE_DETAILS,
    RECEIVE_DETAILS_ERROR,
    SUBMIT_CONFIG_SYMPTOM,
    CLEAR_STATE,
    REQUEST_SET_FAULT_STATE,
    RECEIVE_SET_FAULT_STATE,
    RECEIVE_VERIFICATION_OBSERVATIONS,
    SET_VERIFICATION_OBSERVATION,
    RECEIVE_CREATED_FCS,
    SET_READ_ONLY,
    CHANGE_ACTION_FILTER,
    RECEIVE_ERROR,
    REQUEST_ASSIGN_USERS,
    RECEIVE_ASSIGN_USERS,
    CLEAR_LOADING,
    REQUEST_DWP,
    RECEIVE_DWP_ERROR,
    RECEIVE_DWP
} from "./FaultActions";
import {ACTION_TYPES} from "./common/FaultsConst";

const initialState = {
    assetId: null,
    faultId: null,
    observations: null,
    actions: null,
    actionFilter: [ACTION_TYPES.TEST, ACTION_TYPES.CORRECTIVE_ACTION],
    actionLog: [],
    fetchCount: 0,
    details: null,
    verificationObservations: [],
    comments: [],
    createdFaults: [],
    readOnly: false,
    error: null,
}

export const fault = (state = initialState, action) => {
    let newObservations
    switch (action.type) {
        case SET_ASSET_FAULT:
            return {
                ...state,
                faultId: action.faultId,
                assetId: action.assetId,
            }
        case REQUEST_OBSERVATIONS:
        case REQUEST_SUBMIT_OBSERVATIONS:
        case REQUEST_ACTIONS:
        case REQUEST_SUBMIT_TEST_RESULT:
        case REQUEST_SUBMIT_CORRECTIVE_ACTION_RESULT:
        case REQUEST_SAVE_COMMENT:
        case REQUEST_COMMENTS:
        case REQUEST_ACTION_LOG:
        case REQUEST_DETAILS:
        case REQUEST_SET_FAULT_STATE:
        case REQUEST_ASSIGN_USERS:
        case SUBMIT_CONFIG_SYMPTOM:
        case REQUEST_DWP:
            return {
                ...state,
                fetchCount: state.fetchCount + 1,
            }
        case RECEIVE_SAVE_COMMENT:
            return {
                ...state,
                fetchCount: state.fetchCount - 1,
            }
        case RECEIVE_OBSERVATIONS:
            return {
                ...state,
                fetchCount: state.fetchCount - 1,
                observations: action.observations,
            }
        case RECEIVE_VERIFICATION_OBSERVATIONS:
            return {
                ...state,
                fetchCount: state.fetchCount - 1,
                verificationObservations: action.observations,
            }
        case RECEIVE_ACTIONS:
            return {
                ...state,
                fetchCount: state.fetchCount - 1,
                actions: action.actions,
            }
        case SET_OBSERVATION:
            // This functionality, where symptom doesn't need to be in observation list was added because of HDA
            // because they want to show even reported symptoms on observation page
            const isNewId = state.observations.filter(o => o.id === action.id);
            if (isNewId.length > 0) {
                newObservations = state.observations.map(o => {
                    if (o.id === action.id) {
                        // set changed value to newState property so that we keep original value for visibility
                        // of observations and their benefits
                        return Object.assign({}, o, { newState: action.value})
                    } else {
                        return o;
                    }
                });
            } else {
                state.observations.push({id: action.id, newState: action.value})
                newObservations = state.observations
            }
            return {
                ...state,
                observations: newObservations,
            }
        case SET_VERIFICATION_OBSERVATION:
            newObservations = state.verificationObservations.map(o => {
                if (o.id === action.id) {
                    return Object.assign({}, o, {state: action.value})
                } else {
                    return o;
                }
            });
            return {
                ...state,
                verificationObservations: newObservations,
            }
        case RECEIVE_ACTION_LOG:
            return {
                ...state,
                fetchCount: state.fetchCount - 1,
                actionLog: action.actionLog,
            }
        case RECEIVE_DETAILS:
        case RECEIVE_SUBMIT_OBSERVATIONS:
        case RECEIVE_SUBMIT_TEST_RESULT:
        case RECEIVE_SUBMIT_CORRECTIVE_ACTION_RESULT:
        case RECEIVE_SET_FAULT_STATE:
        case RECEIVE_ASSIGN_USERS:
            return {
                ...state,
                fetchCount: state.fetchCount - 1,
                details: action.details,
            }
        case RECEIVE_DETAILS_ERROR:
        case RECEIVE_ERROR:
        case RECEIVE_DWP_ERROR:
            return {
                ...state,
                fetchCount: state.fetchCount - 1,
                error: action.error.errorKey,
            }
        case RECEIVE_COMMENTS:
            return {
                ...state,
                fetchCount: state.fetchCount - 1,
                comments: action.comments,
            }
        case RECEIVE_CREATED_FCS:
            return {
                ...state,
                fetchCount: state.fetchCount - 1,
                createdFaults: action.faults,
            }
        case CLEAR_STATE:
            return initialState
        case SET_READ_ONLY:
            return {
                ...state,
                readOnly: action.readOnly,
            }
        case CHANGE_ACTION_FILTER:
            return {
                ...state,
                actionFilter: action.selectedActionTypes,
            }
        case CLEAR_LOADING:
            return {
                ...state,
                fetchCount: 0,
            }
        case RECEIVE_DWP:
            return {
                ...state,
                fetchCount: state.fetchCount -1,
                dwp: action.dwp,
            }
        default:
            return state
    }
}